/* Sparklar layout glue. Navigation, predictive search and result rendering remain Enterprise components. */
(() => {
  const categoryParam = 'filter.p.m.custom.h2category';
  const mobileQuery = window.matchMedia('(max-width: 768.98px)');
  const categorySorter = new Intl.Collator('sv', { sensitivity: 'base' });
  let filtersExpanded = false;
  const syncHeaderSpace = () => {
    const header = document.querySelector('store-header');
    if (!header) return;
    // The desktop header reserves its height inline. Recalculate that space when the layout switches to mobile.
    header.parentElement.style.minHeight = `${header.offsetHeight}px`;
    header.spkThreshold = header.offsetHeight + header.parentElement.offsetTop;
    header.handleScroll();
  };
  const updateToolbarState = expanded => {
    const toggle = document.querySelector('.js-toggle-filters');
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.querySelector('[data-filter-label-more]')?.toggleAttribute('hidden', expanded);
    toggle.querySelector('[data-filter-label-less]')?.toggleAttribute('hidden', !expanded);
  };
  const arrangeCategoryButtons = () => {
    const container = document.getElementById('spk-category-filters');
    if (!container?.classList.contains('spk-category-filters')) {
      updateToolbarState(filtersExpanded);
      return;
    }
    const buttons = Array.from(container.querySelectorAll('[data-category-value]'));
    buttons.sort((a, b) => {
      const countDifference = Number(b.dataset.categoryCount) - Number(a.dataset.categoryCount);
      return countDifference || categorySorter.compare(a.dataset.categoryLabel, b.dataset.categoryLabel);
    });
    buttons.forEach(button => container.append(button));
    const limit = Number(mobileQuery.matches ? container.dataset.categoryLimitMobile : container.dataset.categoryLimitDesktop);
    buttons.forEach((button, index) => {
      button.hidden = false;
      if (filtersExpanded || index < limit || button.getAttribute('aria-pressed') === 'true') return;
      button.hidden = true;
    });
    container.dataset.expanded = String(filtersExpanded);
    updateToolbarState(filtersExpanded);
  };
  const setFiltersExpanded = expanded => {
    filtersExpanded = Boolean(expanded);
    const controls = document.querySelector('.spk-collection-controls');
    if (controls) controls.dataset.filtersExpanded = String(filtersExpanded);
    arrangeCategoryButtons();
  };
  const syncCategoryFacet = () => {
    const parent = document.querySelector('#spk-category-filters [data-category-value]');
    document.querySelectorAll('#facets input').forEach(input => {
      if (input.name === categoryParam) {
        const disclosure = input.closest('details-disclosure');
        if (disclosure) disclosure.hidden = !!parent && !mobileQuery.matches;
      }
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-category-value], [data-clear-category], [data-remove-filter], [data-clear-all], [data-filter-retry]');
    if (!button) return;
    const controller = document.querySelector('facet-filters');
    if (!controller?.form) return;
    event.preventDefault();
    clearTimeout(controller.filterChangeTimeout);
    if (button.hasAttribute('data-filter-retry')) {
      controller.applyFilters(controller.spkLastRequest, event);
      return;
    }
    let params;
    if (button.matches('[data-remove-filter], [data-clear-all]')) {
      params = new URL(button.href).searchParams;
    } else {
      params = new URLSearchParams(new FormData(controller.form));
      // Read immediate button state so multiple rapid clicks are retained while a request is pending.
      const selected = new Set(Array.from(document.querySelectorAll('[data-category-value][aria-pressed="true"]'), el => el.dataset.categoryValue));
      if (button.hasAttribute('data-clear-category')) selected.clear();
      else if (selected.has(button.dataset.categoryValue)) selected.delete(button.dataset.categoryValue);
      else selected.add(button.dataset.categoryValue);
      params.delete(categoryParam);
      selected.forEach(value => params.append(categoryParam, value));
      document.querySelectorAll('[data-category-value]').forEach(el => el.setAttribute('aria-pressed', selected.has(el.dataset.categoryValue)));
      document.querySelector('[data-clear-category]')?.setAttribute('aria-pressed', selected.size === 0);
      // Keep price/sort changes made before this request completes in sync with the pending category selection.
      controller.form.querySelectorAll('input').forEach(input => {
        if (input.name === categoryParam) input.checked = selected.has(input.value);
      });
    }
    params.delete('page');
    for (const [key, value] of Array.from(params)) if (!value) params.delete(key);
    // A custom select and drawer can both supply sort_by; send a single value.
    if (params.has('sort_by')) params.set('sort_by', params.get('sort_by'));
    controller.applyFilters(params.toString(), event);
  });
  document.addEventListener('spk:filters-visibility-changed', event => setFiltersExpanded(event.detail.expanded));
  document.addEventListener('on:facet-filters:updated', () => {
    syncCategoryFacet();
    arrangeCategoryButtons();
  });
  document.addEventListener('on:facet-filters:after-close', () => {
    const toggle = document.querySelector('.js-toggle-filters');
    if (toggle && window.innerWidth < 1024) {
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
      setFiltersExpanded(false);
    }
  });
  mobileQuery.addEventListener('change', () => {
    syncCategoryFacet();
    arrangeCategoryButtons();
    syncHeaderSpace();
  });
  document.addEventListener('DOMContentLoaded', () => {
    syncCategoryFacet();
    filtersExpanded = document.querySelector('.js-toggle-filters')?.classList.contains('is-active') || false;
    arrangeCategoryButtons();
    syncHeaderSpace();
    const header = document.querySelector('store-header');
    header?.querySelector('.js-search-input')?.addEventListener('focus', () => header.querySelector('main-menu')?.handleClose());
  });
})();
